import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import App from './container/App';
import { AppContainer } from 'react-hot-loader';

//redux
import configureStore from "./reduxModule/store/configureStore";

//公共资源引入
import './common/css/reset.css';
import './common/css/navBar.less';
import 'amfe-flexible/index.js';
import 'antd-mobile/dist/antd-mobile.css';

//创建app入口
const store = configureStore();

const render = Component => {
    ReactDOM.render(
        <AppContainer>
            <Provider store={store}>
                <BrowserRouter>
                    <Component />
                </BrowserRouter>
            </Provider>
        </AppContainer>,
        document.getElementById('root'),
    )
};

render(App);
if (module.hot) {
    module.hot.accept('./container/App', () => { render(App) })
}

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js